/* Wuschelherz: aus snippets/wh-kampagne.liquid ausgelagert (Perf 1, 2026-11-02). Änderungen hier, nicht im Snippet. */
  (() => {
    if (window.whKampagne) return;
    const KEY = 'wh-ads-src';
    const clean = (v) => String(v || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 100);
    const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } };

    // 1. Herkunft der Sitzung merken (UTM und Klick-IDs roh, damit „Zweites Bild“ und Sparpaket sie weiterreichen)
    try {
      const q = new URLSearchParams(location.search); const src = read(); const utm = {};
      q.forEach((v, k) => { if (/^utm_|^(gclid|gbraid|wbraid|fbclid|ttclid)$/.test(k)) utm[k] = v; });
      let ch = false;
      if (Object.keys(utm).length) { src.utm = utm; ch = true; }
      if (q.get('view') === 'ads') { src.ads = true; ch = true; }
      if (q.has('angle')) { const a = clean(q.get('angle')); if (a) src.angle = a; else delete src.angle; ch = true; }
      if (ch) sessionStorage.setItem(KEY, JSON.stringify(src));
    } catch (e) {}

    // 2. Warenkorb-Attribute
    const isAd = (s) => { const u = s.utm || {}; return !!(s.ads || u.gclid || u.gbraid || u.wbraid || u.fbclid || u.ttclid || /paid|cpc|ppc|display|^ads?$/i.test(u.utm_medium || '')); };
    const wanted = () => {
      const s = read();
      if (!isAd(s) && !clean(s.angle)) return null;
      const u = s.utm || {};
      const out = { _wh_utm_source: clean(u.utm_source), _wh_utm_campaign: clean(u.utm_campaign), _wh_utm_content: clean(u.utm_content), _wh_angle: clean(s.angle) };
      return Object.keys(out).some((k) => out[k]) ? out : null;
    };
    let busyUntil = 0, running = false, timer = 0;
    const schedule = (ms) => { clearTimeout(timer); timer = setTimeout(sync, ms); };
    const sync = async () => {
      const want = wanted(); if (!want || running) return;
      if (Date.now() < busyUntil) { schedule(busyUntil - Date.now() + 500); return; }
      running = true;
      try {
        const c = await fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then((r) => r.json());
        const have = (c && c.attributes) || {};
        // leere Werte entfernen ein altes Attribut derselben Sitzung (Shopify löscht Attribute mit leerem Wert)
        const diff = Object.keys(want).some((k) => String(have[k] || '') !== want[k]);
        if (diff && Date.now() >= busyUntil) {
          await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: want }) });
        } else if (diff) schedule(busyUntil - Date.now() + 500);
      } catch (e) {}
      running = false;
    };
    // „In den Warenkorb“, „Jetzt kaufen“, Sticky-Knopf, Datei dazu: bis zum Neuzeichnen des Warenkorbs nichts schreiben
    document.addEventListener('click', (e) => {
      if (e.target.closest && e.target.closest('.tee-btn--atc, .wh-buy-now, .wh-sticky-cta, [name="add"], .wh-cdd__add')) busyUntil = Date.now() + 15000;
    }, true);
    const watch = () => {
      if (!wanted()) return;
      schedule(1500);
      document.querySelectorAll(/^\/cart\/?$/.test(location.pathname) ? 'cart-drawer, main' : 'cart-drawer').forEach((root) => {
        if (root.dataset.whKa) return; root.dataset.whKa = '1';
        new MutationObserver((list) => {
          if (list.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (/^Cart(Drawer-)?Item-/.test(n.id || '') || (n.querySelector && n.querySelector('[id^="CartDrawer-Item-"], [id^="CartItem-"]')))))) {
            busyUntil = 0;   // Warenkorb neu gezeichnet: der Kauf-Aufruf ist durch
            schedule(2500);
          }
        }).observe(root, { childList: true, subtree: true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    window.whKampagne = { read, wanted, sync };
  })();
